import { EmpReport } from "../../types/EmpReport";
import { EmpReportActionList } from "../actions/empReportAction";
import { Action } from "../actions/types";

const initialValue: Array<EmpReport> = [];

export const empReportReducer = (
  state: EmpReport[] = initialValue,
  action: Action,
): EmpReport[] => {
  switch (action.type) {
    case EmpReportActionList.ADD_EMP_REPORT:
      return [...state, action.data];

    case EmpReportActionList.EDIT_EMP_REPORT: {
      return state.map((report) =>
        report.id === action.id ? { ...report, ...action.data } : report,
      );
    }

    case EmpReportActionList.FETCH_EMP_REPORTS:
      return action.data;

    case EmpReportActionList.DELETE_EMP_REPORT:
      return state.filter((report) => report.id !== action.data);

    default:
      return state;
  }
};
